"use client";
import {
  BlocksRenderer,
  type BlocksContent,
} from "@strapi/blocks-react-renderer";
import Link from "next/link";

const StrapiBlocksRenderer = ({
  content,
  sm = false,
  styledLink = false,
}: {
  content: BlocksContent;
  sm?: boolean;
  styledLink?: boolean;
}) => {
  return (
    <BlocksRenderer
      content={content}
      blocks={{
        paragraph: ({ children }) => (
          <p
            className={`${sm ? "text-sm" : "md:font-p text-[15px]"} font-thin`}
          >
            {children}
          </p>
        ),
        heading: ({ children, level }) => {
          switch (level) {
            case 1:
              return <h1 className="font-h1">{children}</h1>;
            case 2:
              return <h2 className="font-h2">{children}</h2>;
            case 3:
              return <h3 className="font-h3">{children}</h3>;
            case 4:
              return <h4 className="font-h4">{children}</h4>;
            case 5:
              return <h5 className="font-h5">{children}</h5>;
            case 6:
              return <h6 className="font-h6">{children}</h6>;
            default:
              return <h5 className="font-h5">{children}</h5>;
          }
        },
        link: ({ children, url }) => (
          <Link
            target="_blank"
            href={url}
            className={
              styledLink
                ? "text-primary-blue hover:text-blue-light"
                : "underline underline-offset-1"
            }
          >
            {children}
          </Link>
        ),
        list: ({ children, format }) => {
          return format === "ordered" ? (
            <ol className="ml-5 list-decimal font-p py-1">{children}</ol>
          ) : (
            <ul className="ml-5 list-disc font-p py-1">{children}</ul>
          );
        }
      }}
      modifiers={{  
        bold: ({ children }) => <strong>{children}</strong>,
        italic: ({ children }) => <span className="italic">{children}</span>,
      }}
    />
  );
};

export default StrapiBlocksRenderer;
